import { createFileRoute, stripSearchParams } from '@tanstack/react-router'

import { CustomerDetailPage } from '@/features/customers/components/customer-detail-page'
import {
  CUSTOMER_DETAIL_SEARCH_DEFAULTS,
  customerDetailSearchSchema,
} from '@/features/customers/search-schema'

/**
 * /customers/$customerId —— 客户详情(基本信息 + 外部身份 + 关联线索/订单)。
 *
 * 关系表的 tab 态同样进 URL(?tab=orders 冷加载直接落在订单页签);
 * 默认 tab 由 stripSearchParams 摘掉,详情页裸地址保持干净。
 */
export const Route = createFileRoute('/_authed/customers/$customerId')({
  validateSearch: customerDetailSearchSchema,
  search: {
    middlewares: [stripSearchParams(CUSTOMER_DETAIL_SEARCH_DEFAULTS)],
  },
  component: CustomerDetailPage,
})
